<template lang="html">
  <div>
    Report Infestation Form
  </div>
</template>

<script>
export default {
  name: 'report-infestation-form'
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/ReportInfestationForm.vue